import React from "react";
import { useNavigate } from "react-router-dom";

import indus from "../../../assets/images/homepage/indus.svg";
import indusDark from "../../../assets/images/homepage/indusDark.svg";
import wrong from "../../../assets/images/homepage/wrong.svg";
import wrongDark from "../../../assets/images/homepage/wrongDark.svg";

import "../Download/download.scss";
import useTheme from "hooks/observer";

function RenewalCard({ onClose }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleRenewal = () => {
    navigate("/upgrade-plan", { state: { renewalOnly: true } });
  };

  const handleClose = (event) => {
    event.stopPropagation();
    onClose?.();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleRenewal();
    }
  };

  return (
    <div
      className="Download"
      role="button"
      tabIndex={0}
      onClick={handleRenewal}
      onKeyDown={handleKeyDown}
      style={{ cursor: "pointer" }}
    >
      <div className="DownloadIcons">
        <div className="indus">
          <img src={theme === "light" ? indus : indusDark} alt="indus" />
        </div>
        <div className="wrong" onClick={handleClose}>
          <img src={theme === "light" ? wrong : wrongDark} alt="close renewal card" />
        </div>
      </div>
      <p className="DownloadText">
        Click here to renew your plan for the next month or year and continue without interruption.
      </p>
    </div>
  );
}

export default RenewalCard;
